import { ADMIN_TAB_IDS } from '@/components/admin/AdminSidebar';

// Session-scoped memory of the last visited admin section so returning from
// the public website restores working context. Only a tab id is stored —
// never records, user data, payment details or tokens.
const LAST_TAB_KEY = 'admin:last-tab';

export function saveLastAdminTab(tab: string) {
  if (!ADMIN_TAB_IDS.has(tab)) return;
  try {
    sessionStorage.setItem(LAST_TAB_KEY, tab);
  } catch {
    // storage unavailable (private mode etc.) — restoration simply no-ops
  }
}

export function getLastAdminTab(): string | null {
  try {
    const tab = sessionStorage.getItem(LAST_TAB_KEY);
    return tab && ADMIN_TAB_IDS.has(tab) ? tab : null;
  } catch {
    return null;
  }
}

// Link target for "Admin Dashboard" entries: restores the last section,
// while explicit deep links like /admin?tab=ownership always win because
// they carry their own tab parameter.
export function adminDashboardPath(): string {
  const tab = getLastAdminTab();
  return tab && tab !== 'analytics' ? `/admin?tab=${tab}` : '/admin';
}

// Module-level scroll offsets per tab: survive SPA remounts within the
// session without persisting anything to browser storage.
const scrollByTab: Record<string, number> = {};

export function saveAdminScroll(tab: string, y: number) {
  scrollByTab[tab] = y;
}

export function getAdminScroll(tab: string): number {
  return scrollByTab[tab] ?? 0;
}
